// extracted by mini-css-extract-plugin
module.exports = {"card":"_3rUpHBmfitClhGPjr2o0b2","content":"_3Yrae1rsngC7d7GGr-dTkD","function":"_1JmjTEPXDd4fUfc68rURzL","body":"_28n9C4hviIsggdogQbDMFl"};